import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/zhenduan.png'
import _imports_1 from '@/assets/weixiu.png'
import _imports_2 from '@/assets/jiancha.png'
import _imports_3 from '@/assets/menxian.png'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  class: "w-full flex px-4",
  style: {"border-bottom":"1px solid #ffc000"}
}
const _hoisted_3 = { class: "p-3 w-full" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = {
  key: 5,
  class: "flex items-center"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { style: {"color":"#00d1c7ff !important"} }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 4 }
const _hoisted_23 = { key: 5 }
const _hoisted_24 = { key: 6 }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { style: {"color":"#00d1c7ff !important"} }
const _hoisted_29 = {
  key: 8,
  class: "flex items-center"
}
const _hoisted_30 = { style: {"background":"#fff"} }
const _hoisted_31 = { style: {"color":"#fff"} }
const _hoisted_32 = { class: "w-full flex" }
const _hoisted_33 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_34 = { class: "w-full mt-4" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = { class: "flex items-center" }
const _hoisted_37 = {
  class: "w-full",
  style: {"border":"1px solid #171325ff"}
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "flex items-center" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { style: {"margin-top":"8px","color":"#fff"} }
const _hoisted_42 = { class: "w-full flex justify-center mt-4" }
const _hoisted_43 = { style: {"color":"#fff"} }
const _hoisted_44 = { class: "w-full flex" }
const _hoisted_45 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_46 = { class: "w-full mt-4" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { style: {"margin-top":"8px","color":"#fff"} }
const _hoisted_49 = { class: "w-full flex justify-center mt-5" }
const _hoisted_50 = { style: {"color":"#fff"} }
const _hoisted_51 = { class: "w-full flex" }
const _hoisted_52 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_53 = { class: "w-full mt-4" }
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = { class: "flex items-center" }
const _hoisted_56 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_57 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 2 }
const _hoisted_61 = { key: 3 }
const _hoisted_62 = { class: "ml-2" }
const _hoisted_63 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_64 = { class: "ml-2" }
const _hoisted_65 = { key: 2 }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "w-full flex justify-center mt-5" }
const _hoisted_69 = { style: {"color":"#fff"} }
const _hoisted_70 = { class: "w-full flex" }
const _hoisted_71 = {
  class: "text-center w-full",
  style: {"font-size":"24px"}
}
const _hoisted_72 = {
  class: "mt-5",
  style: {"font-size":"16px"}
}
const _hoisted_73 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_74 = {
  key: 0,
  style: {"color":"#00d1c7ff !important"}
}
const _hoisted_75 = {
  class: "mt-10 mb-4",
  style: {"font-size":"16px"}
}
const _hoisted_76 = { class: "flex mt-4" }
const _hoisted_77 = { class: "w-full flex justify-center mt-5" }
const _hoisted_78 = ["src"]
const _hoisted_79 = { style: {"max-height":"600px","overflow-y":"auto"} }

import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { langList } from "../../common/lang";
import {
  getFactoryName,
  getGroupName,
  transformDate2,
  getGroupListByFactory,
} from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import { message } from "ant-design-vue";
import SelectMachineComponent from "./select-machine.vue";
import SelectSensorComponent from "./select-sensor.vue";
import DiagnosticReportDetails from "../report4/common/DiagnosticReportDetails2.vue";
import { Dayjs } from "dayjs";
import {
  getLanguage,
  getTranslation,
  getChineseFt,
} from "../../common/translate";


export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

let conditionLists = [
  { label: "健康", value: 1, realValue: [0] },
  { label: "可用", value: 2, realValue: [1, 2] },
  { label: "警戒", value: 3, realValue: [3, 4, 5] },
  { label: "故障", value: 4, realValue: [6, 7] },
];

let whetherList = [
  { label: "是", value: true },
  { label: "否", value: false },
];

const router = useRouter();
let langObj: any = ref({});
let language: any = ref("English");
const getLang = () => {
  language.value = localStorage.getItem("language") || "English";
  langObj.value = langList[language.value];

  conditionLists = [
    { label: langObj.value["健康"], value: 1, realValue: [0] },
    { label: langObj.value["可用"], value: 2, realValue: [1, 2] },
    { label: langObj.value["警戒"], value: 3, realValue: [3, 4, 5] },
    { label: langObj.value["故障"], value: 4, realValue: [6, 7] },
  ];
};
getLang();

const pagination = computed(() => ({
  total: searchModel.value.total,
  current: searchModel.value.skip,
  pageSize: searchModel.value.take,
}));
let menuSelect = ref(1); //1: 设备列表  2：测点列表
let searchModel: any = ref({
  skip: 1,
  take: 10,
  keyWord: "",
  groupId: null,
  machineId: "",
  condition: null,
  status: null,
  sensorPlace: "",
  sensorSn:""
});
let conditionList = [
  { label: "健康", value: 0, color: "#61c08f" },
  { label: "可用", value: 1, color: "#706a00ff" },
  { label: "可用", value: 2, color: "#706a00ff" },
  { label: "警戒", value: 3, color: "#cd5f3b" },
  { label: "警戒", value: 4, color: "#cd5f3b" },
  { label: "警戒", value: 5, color: "#cd5f3b" },
  { label: "故障", value: 6, color: "#921e37" },
  { label: "故障", value: 7, color: "#921e37" },
];

let statusList = [
  { label: "运行", value: 1, color: "#0AF9F6" },
  { label: "停机", value: 0, color: "rgb(162, 166, 171)" },
];

let data = ref([]);

const machineColumns = [
  {
    title: langObj.value["设备编号"],
    dataIndex: "machineCode",
  },
  {
    title: langObj.value["设备名称"],
    dataIndex: "machineName",
  },
  {
    title: langObj.value["所属工厂"],
    dataIndex: "factoryId",
  },
  {
    title: langObj.value["设备区域"],
    dataIndex: "groupId",
  },
  {
    title: langObj.value["设备位置"],
    dataIndex: "position",
  },
  {
    title: langObj.value["设备厂家"],
    dataIndex: "supplier",
  },
  {
    title: langObj.value["设备型号"],
    dataIndex: "model",
  },
  {
    title: langObj.value["设备类型"],
    dataIndex: "machineTypeAll",
  },
  {
    title: langObj.value["设备类型缩写"],
    dataIndex: "machineType",
  },
  {
    title: langObj.value["设备SN号"],
    dataIndex: "sn",
  },
  {
    title: langObj.value["设备序号"],
    dataIndex: "sort",
  },
  // {
  //   title: langObj.value["是否实验台"],
  //   dataIndex: "experiment",
  // },
  {
    title: langObj.value["设备描述"],
    dataIndex: "remark",
  },
  // {
  //   title: langObj.value["健康状态"],
  //   dataIndex: "condition",
  // },
  // {
  //   title: langObj.value["运行状态"],
  //   dataIndex: "status",
  // },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
  },
];

const sensorColumns = [
  {
    title: langObj.value["传感器SN"],
    dataIndex: "sensorSn",
  },
  {
    title: langObj.value["测点位置"],
    dataIndex: "sensorPlace",
  },
  {
    title: langObj.value["设备区域"],
    dataIndex: "groupId",
  },
  {
    title: langObj.value["所属设备"],
    dataIndex: "machineName",
  },
  {
    title: langObj.value["测点ID"],
    dataIndex: "id",
  },
  {
    title: langObj.value["传感器电量"],
    dataIndex: "hardware",
  },
  {
    title: langObj.value["启用状态"],
    dataIndex: "disableUse",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
  },
];

let groupList: any = ref([]);
let machineList: any = ref([]);
let machineTypeList: any = ref([]);
let machineTypeListAll: any = ref([]);
let dataTypeList = ref<any>();
let isEditable: any = ref(false);

let options: any = ref([]);
let categoryAll: any = ref([]);

onMounted(() => { 
  isEditable.value = true;
  getAdmin();
  loadDatatype();
  getMachineType();
  getGroupList();
  search();
  getSearch3();
});

let admin = ref(false);
const getAdmin = () => {
  let member = JSON.parse(localStorage.getItem("memberInfo") || "");
  admin.value = member?.admin;
};

const getSearch3 = async () => {
  let config: any = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/external/inspection/threshold", config);
  if (result?.data) {
    categoryAll.value = JSON.parse(JSON.stringify(result.data));
  }

  options.value = [];
  let first = categoryAll.value.map((p: any) => p.firstCategory);
  first = [...new Set(first)];
  let list: any = [];
  first.map((f: any) => {
    let firstList: any = {
      label: f,
      value: f,
      children: [],
    };
    let second = categoryAll.value
      .filter((p: any) => p.firstCategory === f)
      .map((p: any) => p.secondCategory);
    second = [...new Set(second)];
    second.map((s: any) => {
      let secondList: any = {
        label: s,
        value: s,
        children: [],
      };
      let third = categoryAll.value
        .filter((p: any) => p.firstCategory === f && p.secondCategory === s)
        .map((p: any) => p.thirdCategory);
      third = [...new Set(third)];
      third.map((t: any) => {
        let thirdList: any = {
          label: t,
          value: t,
        };
        secondList.children.push(thirdList);
      });
      firstList.children.push(secondList);
    });

    list.push(firstList);
  });

  options.value = list;
};

const loadDatatype = () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/sensors/datatype", config).then((res: any) => {
    if (res) {
      dataTypeList.value = res.data.map((t: any) => ({
        value: t.name,
        label: langObj.value[t.name] || t.name,
      }));
    }
  });
};

// 获取设备类型
const getMachineType = async () => {
  let result = await request("/api/sensors/machine-types");
  if (result && result.data) {
    machineTypeListAll.value = result.data;
    let firstCategoryList = result.data.map((d: any) => d.FirstCategory);
    firstCategoryList = [...new Set(firstCategoryList)];
    let list: any = [];
    firstCategoryList.map((d1: any) => {
      let first: any = {
        value: d1,
        label: language.value === "Chinese_ft" ? getChineseFt(d1) : d1,
        children: [],
      };
      let list1 = [
        ...new Set(
          result.data
            .filter((p: any) => p.FirstCategory === d1)
            .map((p: any) => p.SecondCategory)
        ),
      ];

      list1.map((d2: any) => {
        let second: any = {
          value: d2,
          label: language.value === "Chinese_ft" ? getChineseFt(d2) : d2,
          children: [],
        };

        let list2 = result.data
          .filter((p: any) => p.SecondCategory === d2 && p.FirstCategory === d1)
          .map((p: any) => p.ThirdCategory);

        list2.map((d3: any) => {
          let third = {
            value: d3,
            label: language.value === "Chinese_ft" ? getChineseFt(d3) : d3,
          };

          second.children.push(third);
        });

        first.children.push(second);
      });

      list.push(first);
    });
    machineTypeList.value = list;
  }
};

// 获取区域列表
const getGroupList = () => {
  groupList.value = getGroupListByFactory();
};

// 选择区域
const selectGroup = (ev: any) => {
  let memberInfo = JSON.parse(localStorage.getItem("memberInfo") || "");
  searchModel.value.machineId = "";
  if (ev) {
    machineList.value = memberInfo.machines.filter(
      (p: any) => p.groupId === ev
    );
  } else {
    machineList.value = [];
  }
};

const search = () => {
  searchModel.value.skip = 1;
  getData();
};

const getData = () => {
  if (menuSelect.value === 1) {
    getMachineList();
  }

  if (menuSelect.value === 2) {
    searchSensor();
  }
};

//获取设备列表
const getMachineList = async () => {
  let config: any = {
    params: {
      groupId: searchModel.value.groupId,
      status: searchModel.value.status,
      factoryId: localStorage.getItem("factory_id"),
      keyWord: searchModel.value.keyWord,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  if (searchModel.value.condition) {
    config.params.conditionList = conditionLists.find(
      (p: any) => p.value === searchModel.value.condition
    )?.realValue;
  }

  let result = await request("/api/machines", config);

  if (result && result.status === 200) {
    result.data.map((d: any) => {
      if (d.machineTypeId) {
        let info = machineTypeListAll.value.find(
          (p: any) => p.id === d.machineTypeId
        );
        console.log("info", info);
        if (info) {
          if (language.value === "Chinese") {
            d.machineTypeAll = `${info.FirstCategory}/${info.SecondCategory}/${info.ThirdCategory}`;
          } else if (language.value === "English") {
            d.machineTypeAll = `${
              info.FirstCategoryEng || info.FirstCategory
            }/${info.SecondCategoryEng || info.SecondCategory}/${
              info.ThirdCategoryEng || info.ThirdCategory
            }`;
          } else if (language.value === "Chinese_ft") {
            d.machineTypeAll = `${info.FirstCategoryFt || info.FirstCategory}/${
              info.SecondCategoryFt || info.SecondCategory
            }/${info.ThirdCategoryFt || info.ThirdCategory}`;
          }
        } else {
          d.machineTypeAll = "";
        }
      }
    });
    data.value = result.data;
  }
};

// 获取测点列表
const searchSensor = () => {
  if (!groupList.value?.length) {
    return;
  }
  searchModel.value.groupId = groupList.value[0].id;
  selectGroup(searchModel.value.groupId);
  if (!machineList.value?.length) {
    return;
  }
  searchModel.value.machineId = machineList.value[0].id;
  getSensorList();
};

const getSensorList = async () => {
  // if (!searchModel.value.machineId) {
  //   return message.warning("请选择设备后查询");
  // }

  data.value = [];
  let config: any = {
    params: {
      machineId: searchModel.value.machineId,
      keyWord: searchModel.value.keyWord,
      factoryId: localStorage.getItem("factory_id"),
      sensorSn:searchModel.value.sensorSn,
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/sensors", config);

  if (result && result.status === 200) {
    data.value = result.data;
  }
};

// 重置
const reset = () => {
  if (menuSelect.value === 1) {
    searchModel.value = {
      ...searchModel.value,
      keyWord: "",
      groupId: null,
      machineId: "",
      condition: null,
      status: null,
      sensorPlace: "",
    };
  } else {
    searchModel.value = {
      ...searchModel.value,
      keyWord: "",
      condition: null,
      status: null,
      sensorPlace: "",
    };
  }
};

const selectMenu = (ev: any) => {
  menuSelect.value = ev;
  data.value = [];
  reset();
  getData();
};

// 获取设备健康状态
const getMachienCondition = (ev: any) => {
  if (ev && ev.workStatus && ev.workStatus.stableCondition) {
    return conditionList.find(
      (p: any) => p.value === ev.workStatus.stableCondition
    );
  } else {
    return conditionList[0];
  }
};

// 获取设备运行状态
const getMachienStatus = (ev: any) => {
  if (ev && ev.workStatus && ev.workStatus.scoreWkStatus) {
    return statusList.find((p: any) => p.value === ev.workStatus.scoreWkStatus);
  } else {
    return statusList[1];
  }
};

const getRowClassName = (record: any, index: any) => {
  // 根据索引设置不同的类名
  return index % 2 === 0 ? "even-row" : "odd-row";
};

// 新增测点
let visibleAddSensor = ref(false);
let sensorForm: any = ref({
  sensorSn: null,
  sensorPlace: "",
  machineName: "",
  machineId: "",
  fcSensorId: "",
  fcSensorPlace: "",
  machineTypeId: "",
  national: "",
  remark: "",
  type: null,
  sensorGroup: [{ coordinate: "", sonId: "", sensorGroupName: "" }],
  disable: false,
  onOff: null,
  quotaInterval: null,
  inspectionSubId: null,
  inspectionSubs: null,
  defaultSpeed: null,
});
let powerEtcList: any = ref([]);
let selectMachineVisible = ref(false);
let selectSensorVisible = ref(false);
const sensorAddColumns = [
  {
    title: langObj.value["编号"],
    dataIndex: "sonId",
  },
  {
    title: langObj.value["轴向"],
    dataIndex: "coordinate",
  },
  {
    title: langObj.value["名称"],
    dataIndex: "sensorGroupName",
  },
  {
    title: langObj.value["联系人"],
    dataIndex: "value",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
  },
];
const addSensor = () => {
  sensorForm.value = {
    sensorSn: null,
    sensorPlace: "",
    machineName: "",
    machineId: "",
    fcSensorId: "",
    fcSensorPlace: "",
    machineTypeId: "",
    national: null,
    remark: "",
    dataType: ["高频加速度", "低频加速度Z", "速度Z"],
    type: null,
    sensorGroup: [{ coordinate: "", sonId: "", sensorGroupName: "" }],
    disable: false,
    onOff: null,
    quotaInterval: null,
    inspectionSubId: null,
    inspectionSubs: null,
    defaultSpeed: null,
  };
  machineFileList.value = [];
  visibleAddSensor.value = true;
  setTimeout(() => {
    sensorForm1.value.clearValidate();
  }, 200);
};
let speedList: any = ref([]);

// 选择设备
const selectMachineS = () => {
  selectMachineVisible.value = true;
};

const selectMachineSen = (ev: any) => {
  selectMachineVisible.value = false;
  if (ev) {
    sensorForm.value.machineId = ev.id;
    sensorForm.value.machineName = ev.machineName;
  } else {
    sensorForm.value.machineId = "";
    sensorForm.value.machineName = "";
  }
};

//选择转频提取测点
const selectSensorS = () => {
  if (!sensorForm.value.machineId) {
    message.warning("请选择所属设备后选择转频提取测点");
    return;
  }

  selectSensorVisible.value = true;
};

const selectSensorSen = (ev: any) => {
  selectSensorVisible.value = false;
  if (ev) {
    sensorForm.value.fcSensorId = ev.id;
    sensorForm.value.fcSensorPlace = ev.sensorPlace;
  } else {
    sensorForm.value.fcSensorId = "";
    sensorForm.value.fcSensorPlace = "";
  }
};

// 选择类型
const changeThirdTypeId = async (ev: any) => {
  if (ev && ev.length === 3) {
    let info = machineTypeListAll.value.find(
      (p: any) =>
        p.FirstCategory === ev[0] &&
        p.SecondCategory === ev[1] &&
        p.ThirdCategory === ev[2]
    );
    sensorForm.value.machineTypeId = info.id;

    let config = {
      params: { id: info.id },
      headers: {
        requestId: uuidv4(),
      },
    };

    let result = await request.get(
      "/api/sensors/machine-types/power-etc",
      config
    );
    if (!result?.data) {
      powerEtcList.value = [];
      sensorForm.value.national = null;
      return;
    }

    powerEtcList.value = result.data;
    if (result.data.length > 0) {
      sensorForm.value.national = result.data[0].powerEtc;
    } else {
      sensorForm.value.national = null;
    }
  }
};

// 选择功率
const changeNational = (ev: any) => {};

const addSensorParmar = () => {
  sensorForm.value.sensorGroup.push({ coordinate: "Y" });
};

const deleteSensorParmar = (ev: any) => {
  sensorForm.value.sensorGroup.splice(ev, 1);
};

// 选择巡检设备细分
const changeISub = (ev: any) => {
  if (ev.length === 3) {
    speedList.value = categoryAll.value.filter(
      (p: any) =>
        p.firstCategory === ev[0] &&
        p.secondCategory === ev[1] &&
        p.thirdCategory === ev[2]
    );
  } else {
    speedList.value = [];
  }
};

// 编辑
const editSensor = async (ev: any) => {
  machineFileList.value = [];
  let evValue = JSON.parse(JSON.stringify(ev));
  sensorForm.value = evValue;

  if (sensorForm.value?.inspectionSubs?.length === 3) {
    speedList.value = categoryAll.value.filter(
      (p: any) =>
        p.firstCategory === sensorForm.value.inspectionSubs[0] &&
        p.secondCategory === sensorForm.value.inspectionSubs[1] &&
        p.thirdCategory === sensorForm.value.inspectionSubs[2]
    );
  } else {
    speedList.value = [];
  }

  if (ev.machineTypeId) {
    let info = machineTypeListAll.value.find(
      (p: any) => p.id === ev.machineTypeId
    );
    if (info) {
      sensorForm.value.type = [
        info.FirstCategory,
        info.SecondCategory,
        info.ThirdCategory,
      ];

      let configEtc = {
        params: { id: info.id },
        headers: {
          requestId: uuidv4(),
        },
      };

      let resultEtc = await request.get(
        "/api/sensors/machine-types/power-etc",
        configEtc
      );
      if (resultEtc) {
        powerEtcList.value = resultEtc.data;
      }
    } else {
      sensorForm.value.type = [];
    }
  }

  if (ev.machine) {
    sensorForm.value.machineName = ev.machine.machineName;
  }

  if (sensorForm.value.pictures) {
    sensorForm.value.pictures.map((p: any) => {
      p.type = "";
    });
    machineFileList.value = sensorForm.value.pictures;
  }

  visibleAddSensor.value = true;
  setTimeout(() => {
    sensorForm1.value.clearValidate();
  }, 200);
};

const disableUseSensor= async (ev: any,disableUse:any) => {
  const data = {
    id: ev.id,
    disableUse:disableUse,
    sensorSn:ev.sensorSn
  };
  let result = await request.put("/api/sensors/changeStatus", data);
  if (result?.data) {
    message.success(getLanguage("操作成功"));
    getSensorList();
  } else {
    message.warning("操作失败");
  }
}

// 删除测点
const deleteSensor = async (ev: any) => {
  const config = {
    params: {
      id: ev.id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.delete("/api/sensors/info", config);
  if (result?.data) {
    message.success(getLanguage("操作成功"));
    getSensorList();
  } else {
    message.warning("操作失败");
  }
};

let sensorForm1 = ref();
const submitSensor = () => {
  sensorForm1.value?.clearValidate();
  sensorForm1.value
    .validate()
    .then(async (res: any) => {
      let form = JSON.parse(JSON.stringify(sensorForm.value));
      if (form.inspectionSubs?.length !== 3) {
        form.inspectionSubs = [];
      }
      if (form.type && form.type.length === 3) {
        let info = machineTypeListAll.value.find(
          (p: any) =>
            p.FirstCategory === form.type[0] &&
            p.SecondCategory === form.type[1] &&
            p.ThirdCategory === form.type[2]
        );
        form.machineTypeId = info.id;
      } else {
        form.machineTypeId = null;
      }
      delete form.type;

      if (machineFileList.value && machineFileList.value.length) {
        form.pictures = machineFileList.value.map((p: any) => ({
          url: p.url,
          type: 9,
        }));
      }

      delete form.threshold;

      let result: any = form.id
        ? await request.put("/api/sensors/info", form)
        : await request.post("/api/sensors", form);

      if (result && result.status == 200) {
        message.success(getLanguage("操作成功"));
        visibleAddSensor.value = false;
        getSensorList();
      } else {
        message.warning("操作失败");
      }
    })
    .catch((err: any) => {
      console.log(err); //失败后执行
    });
};

// 获取转速范围
const getSpeenRange = (ev: any) => {
  return categoryAll.value.find((p: any) => p._id === ev)?.speedRange;
};
// 获取巡检细分显示名称
const getInspectionSubs = (ev: any) => {
  if (ev?.length === 3) {
    return ev.join("/");
  } else {
    return "";
  }
};

// 新增设备
let visibleAddMachine = ref(false);
let machineForm: any = ref({
  machineCode: null,
  groupId: null,
  type: null,
  machineName: "",
  position: null,
  supplier: null,
  model: null,
  machineType: null,
  machineTypeId: null,
  sn: null,
  sort: null,
  experiment: false,
  remark: null,
  pictures: [],
  factoryId: "",
  parentFactoryId: "",
  params: {},
  bitNumber: null,
  machinePower: null,
  mode: [],
});
let macForm = ref();
const addMachine = () => {
  machineForm.value = {
    machineCode: null,
    groupId: null,
    type: null,
    machineName: "",
    position: null,
    supplier: null,
    model: null,
    machineType: null,
    machineTypeID: null,
    sn: null,
    sort: null,
    experiment: false,
    remark: null,
    pictures: [],
    factoryId: "",
    parentFactoryId: "",
    params: {},
    bitNumber: null,
    machinePower: null,
    mode: [1],
  };
  machineFileList.value = [];
  visibleAddMachine.value = true;
  setTimeout(() => {
    macForm.value.clearValidate();
  }, 200);
};

const editMachine = async (ev: any) => {
  machineFileList.value = [];
  let dataValue = JSON.parse(JSON.stringify(ev));
  if (!dataValue.params) {
    dataValue.params = {};
  }
  if (!dataValue.mode) {
    dataValue.mode = [];
  }
  delete dataValue.machineTypeAll;
  machineForm.value = dataValue;
  if (ev.machineTypeId) {
    let info = machineTypeListAll.value.find(
      (p: any) => p.id === ev.machineTypeId
    );
    if (info) {
      machineForm.value.type = [
        info.FirstCategory,
        info.SecondCategory,
        info.ThirdCategory,
      ];
    } else {
      machineForm.value.type = null;
    }
  }

  if (machineForm.value.pictures) {
    machineForm.value.pictures.map((p: any) => {
      p.type = "";
    });
    machineFileList.value = machineForm.value.pictures;
  }

  visibleAddMachine.value = true;
  setTimeout(() => {
    macForm.value.clearValidate();
  }, 200);
};

const selectGroupM = (ev: any) => {
  machineForm.value.factoryId = groupList.value.find(
    (p: any) => p.id === ev
  )?.factoryId;
  machineForm.value.parentFactoryId = groupList.value.find(
    (p: any) => p.id === ev
  )?.parentId;
};

const deleteMachine = async (ev: any) => {
  const config = {
    params: {
      id: ev.id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.delete("/api/machines/info", config);
  console.log("result", result);
  if (result?.data) {
    message.success("删除成功！");
    getData();
  } else {
    message.warning("操作失败,请联系管理员!");
  }
};

//设备图片
let machineFileList = ref<any>([]);

let customRequest = async (options: any) => {
  const { onSuccess, onError, file } = options;
  let formData = new FormData();
  formData.append("file", file); // file为要上传的文件
  const config = {
    headers: {
      requestId: uuidv4(),
      "Content-Type": "multipart/form-data",
    },
  };
  let res = await request.post("/api/upload", formData, config);
  if (res) {
    file.url = res.data;
    onSuccess({ url: file.url, status: "done" });
  }
};

//**图片上传* */
const previewVisible = ref(false);
const previewImage = ref("");
const previewTitle = ref("");
const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = "";
};

const handlePreview = async (file: any) => {
  previewImage.value = file.url;
  previewVisible.value = true;
  previewTitle.value = "";
};

const submitMachine = () => {
  macForm.value?.clearValidate();
  macForm.value
    .validate()
    .then(async (res: any) => {
      let form = JSON.parse(JSON.stringify(machineForm.value));
      if (machineFileList.value && machineFileList.value.length) {
        form.pictures = machineFileList.value.map((p: any) => ({
          url: p.url,
          type: 1,
        }));
      }

      if (form.type && form.type.length === 3) {
        let info = machineTypeListAll.value.find(
          (p: any) =>
            p.FirstCategory === form.type[0] &&
            p.SecondCategory === form.type[1] &&
            p.ThirdCategory === form.type[2]
        );
        form.machineTypeId = info.id;
      } else {
        form.machineTypeId = null;
      }
      delete form.type;

      let result = form.id
        ? await request.put("/api/machines/info", form)
        : await request.post("/api/machines", form);
      if (result && result.status === 200) {
        message.success(getLanguage("操作成功"));
        visibleAddMachine.value = false;
        getData();
      } else {
        message.warning("操作失败,请联系管理员!");
      }
    })
    .catch((err: any) => {
      console.log(err); //失败后执行
    });
};

// 报警记录
let visibleWarning = ref(false);
let warningList: any = ref([]);
let warnSearchModel: any = ref({
  machineId: null,
  date: null,
  type: null,
  condition: null,
  skip: 1,
  take: 20,
  total: 0,
  keyWord: "",
});
const warmPagination = computed(() => ({
  total: warnSearchModel.value.total,
  current: warnSearchModel.value.skip,
  pageSize: warnSearchModel.value.take,
}));
const changeWarnTable = (pagination: any) => {
  searchModel.value.skip = pagination.current;
  searchModel.value.take = pagination.pageSize;
  getWarningList();
};
let warnTypeList = [
  { label: "智能诊断", value: 1 },
  { label: "门限报警", value: 4 },
];
let warningColumns = [
  {
    title: langObj.value["报警时间"],
    dataIndex: "date",
  },
  {
    title: langObj.value["报警类型"],
    dataIndex: "type",
  },
  {
    title: langObj.value["严重程度"],
    dataIndex: "condition",
  },
  {
    title: langObj.value["测点"],
    dataIndex: "sensorPlace",
  },
  {
    title: langObj.value["报警内容"],
    dataIndex: "diagnosticNotes",
  },
  {
    title: langObj.value["联系人"],
    dataIndex: "contactName",
  },
  {
    title: langObj.value["处理状态"],
    dataIndex: "status",
  },
  {
    title: langObj.value["操作"],
    dataIndex: "act",
  },
];

const resetWarn = () => {
  warnSearchModel.value = {
    ...warnSearchModel.value,
    date: null,
    type: null,
    condition: null,
  };
};

const openMachineWarining = (ev: any) => {
  warnSearchModel.value.machineId = ev.id;
  visibleWarning.value = true;
  warnSearchModel.value.skip = 1;
  resetWarn();
  getWarningList();
};

const getWarningList = async () => {
  warningList.value = [];
  let config: any = {
    params: {
      skip: warnSearchModel.value.skip,
      take: warnSearchModel.value.take,
      machineId: warnSearchModel.value.machineId,
      typeList: [1, 4],
    },
    headers: {
      requestId: uuidv4(),
    },
  };
  if (warnSearchModel.value.type) {
    delete config.params.typeList;
    config.params.type = warnSearchModel.value.type;
  }

  if (warnSearchModel.value.date && warnSearchModel.value.date.length === 2) {
    config.params.begin = transformDate2(
      new Date(warnSearchModel.value.date[0]),
      1
    );
    config.params.end = transformDate2(
      new Date(warnSearchModel.value.date[1]),
      2
    );
  }

  if (warnSearchModel.value.condition) {
    config.params.conditionList = conditionLists.find(
      (p: any) => p.value === warnSearchModel.value.condition
    )?.realValue;
  }

  let result = await request.get("/api/workflows", config);
  if (result) {
    warningList.value = result.data.list;
    warnSearchModel.value.total = result.data.total;
  }
};

//检修记录
let visibleRepair = ref(false);
let repairForm: any = ref({
  list: [],
});

let repairColumns = [
  {
    title: "报警时间",
    dataIndex: "id",
  },
  {
    title: "严重程度",
    dataIndex: "id",
  },
  {
    title: "故障描述",
    dataIndex: "id",
  },
];

let accuracyList = [
  { label: "健康", value: 0 },
  { label: "可用", value: 1 },
  { label: "警戒", value: 2 },
  { label: "故障", value: 3 },
  { label: "不确定", value: 4 },
];

const getRepairInfo = async (id: any) => {
  repairForm.value = { list: [] };

  let config: any = {
    params: {
      id,
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  let result = await request.get("/api/reports/info", config);

  if (result && result.data) {
    repairForm.value = {
      begin: result.data.repairReport.begin,
      end: result.data.repairReport.end,
      maintainMessage: result.data.repairReport.maintainMessage,
      maintainPerson: result.data.repairReport.maintainPerson,
      machineName: result.data.machines[0].machineName,
      accuracy: accuracyList.find(
        (p: any) => p.value === result.data.repairReport.accuracy
      )?.label,
    };
    if (result.data.machines.length) {
      repairForm.value.groupName = getGroupName(
        result.data.machines[0].groupId
      );
    }
  }
};

// 健康总览
const viewMachine = (ev: any) => {
  if (ev) {
    localStorage.setItem("machine_id", ev.id);
    router.push("/diagnosisN/overview");
  }
};

// 查看专家报告
let visibleReport = ref(false);
let reportId = ref("");
let mrDref = ref();
const viewReport = (ev: any) => {
  visibleReport.value = true;
  reportId.value = ev.reportIds[0];
  setTimeout(() => {
    mrDref.value.show(ev.reportIds[0]);
  }, 500);
};
const cancel = (ev: any) => {
  if (ev) {
    visibleReport.value = false;
    reportId.value = "";
  }
};

const dates = ref<any>();

const disabledDate = (current: Dayjs) => {
  if (!dates.value || (dates.value as any).length === 0) {
    return false;
  }
  const tooLate = dates.value[0] && current.diff(dates.value[0], "days") > 60;
  const tooEarly = dates.value[1] && dates.value[1].diff(current, "days") > 60;
  return tooEarly || tooLate;
};

const onCalendarChange = (val: any) => {
  dates.value = val;
};

let allNodes: any = [];
let nodeList = ref<any>([]);
const expandedKeys = ref<string[]>([]);

let modalNodeState = reactive({
  visible: false,
  title: "选择绑定",
  confirmLoading: false,
});
const openNodeModal = () => {
  modalNodeState.visible = true;
  if (nodeList.value.length == 0) {
    loadNodes();
  }
};

const buildTree = (items: any, node_parent_id = "") => {
  const result = [];
  for (let item of items) {
    item = Object.assign({}, item);
    if (item.node_parent_id === node_parent_id) {
      const children = buildTree(items, item.id);
      if (children.length > 0) {
        item.children = children;
      }
      item.title = item.node_name;
      item.expand = false;
      item.value = item.id;
      item.label = item.node_name;
      item.title = item.node_name;
      item.key = item.id;
      if (![22, 23].includes(item.node_type)) {
        result.push(item);
      }

      if (!item.node_parent_id) {
        expandedKeys.value.push(item.id);
      }
    }
  }
  return result;
};

let loadNodes = async () => {
  if (allNodes.length == 0) {
    const config = {
      params: {},
      headers: {
        requestId: uuidv4(),
      },
    };

    let result = await request.get("/api/dt/das/node", config);
    if (result && !!result.data && !!result.data.data) {
      //自研das
      allNodes = result.data.data;
    } else if (result && !!result.data) {
      //DT
      result.data.map(function (node) {
        node.id = node.node_id;
        node.group_id = node.grouid;
        if (!!!node.node_parent_id) {
          node.node_parent_id = "";
        }
      });
      allNodes = result.data;
    }
  }

  nodeList.value = buildTree(allNodes);
};

let selectTree = (key: any, val: any) => {
  if (val.node.node_type > 10) {
    sensorForm.value.sensorGroup.length = 0;
    var is3 = [];
    if (!!sensorForm.value.dataType) {
      is3 = sensorForm.value.dataType.filter(
        (p: any) => !!p && (p.indexOf("X") >= 0 || p.indexOf("Y") >= 0)
      ); //包含XY指标/波形时，判断为三轴，否则为单轴
    }
    if (!!is3 && is3.length > 0) {
      var nodegroup = allNodes.filter(
        (p: any) =>
          p.group_id == val.node.group_id &&
          p.node_parent_id == val.node.node_parent_id
      );
      nodegroup.map(function (node) {
        var sgname =
          node.node_type == 21
            ? "竖直径向"
            : node.node_type == 22
            ? "轴向"
            : node.node_type == 23
            ? "水平径向"
            : "";
        var cd =
          node.node_type == 21
            ? "Z"
            : node.node_type == 22
            ? "X"
            : node.node_type == 23
            ? "Y"
            : "";
        sensorForm.value.sensorGroup.push({
          coordinate: cd,
          sonId: node.id,
          sensorGroupName: sgname,
          node_name: val.node.parent.node.node_name + "/" + node.node_name,
        });
      });
    } else {
      var sgname =
        val.node.node_type == 21
          ? "竖直径向"
          : val.node.node_type == 22
          ? "轴向"
          : val.node.node_type == 23
          ? "水平径向"
          : "";
      var cd =
        val.node.node_type == 21
          ? "Z"
          : val.node.node_type == 22
          ? "X"
          : val.node.node_type == 23
          ? "Y"
          : "";
      sensorForm.value.sensorGroup.push({
        coordinate: cd,
        sonId: val.node.id,
        sensorGroupName: sgname,
        node_name: val.node.parent.node.node_name + "/" + val.node.node_name,
      });
    }
    modalNodeState.visible = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_close_outlined = _resolveComponent("close-outlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_BankOutlined = _resolveComponent("BankOutlined")!
  const _component_HddOutlined = _resolveComponent("HddOutlined")!
  const _component_AimOutlined = _resolveComponent("AimOutlined")!
  const _component_ApartmentOutlined = _resolveComponent("ApartmentOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        style: _normalizeStyle([{"font-size":"18px"}, { borderBottom: _unref(menuSelect) === 1 ? '4px solid #ffc000' : '' }]),
        class: "py-3 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectMenu(1)))
      }, _toDisplayString(_unref(langObj)["设备列表"]), 5),
      _createElementVNode("div", {
        style: _normalizeStyle([{"font-size":"18px"}, { borderBottom: _unref(menuSelect) === 2 ? '4px solid #ffc000' : '' }]),
        class: "py-3 ml-12 cursor-pointer",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectMenu(2)))
      }, _toDisplayString(_unref(langObj)["测点列表"]), 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(menuSelect) === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_form, {
              model: _unref(searchModel),
              name: "horizontal_login",
              layout: "inline",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['设备区域'],
                  name: "groupId",
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _unref(searchModel).groupId,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchModel).groupId) = $event)),
                      style: {"width":"220px"},
                      allowClear: "",
                      placeholder: _unref(langObj)['请选择区域']
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(getLanguage)('名称/编号', _unref(language)),
                  name: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _unref(searchModel).keyWord,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchModel).keyWord) = $event)),
                      placeholder: _unref(langObj)['请输入设备名称/编号']
                    }, null, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        onClick: reset,
                        class: "box px-5 py-1 fff cursor-pointer ml-4"
                      }, _toDisplayString(_unref(langObj)["重置"]), 1),
                      _createElementVNode("div", {
                        onClick: getData,
                        class: "box px-5 py-1 fff cursor-pointer ml-4",
                        style: {"background-color":"#171325ff"}
                      }, _toDisplayString(_unref(langObj)["查询"]), 1),
                      (_unref(isEditable))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: addMachine,
                            class: "box px-5 py-1 fff cursor-pointer ml-4",
                            style: {"background-color":"#171325ff"}
                          }, _toDisplayString(_unref(langObj)["新建设备"]), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_table, {
                style: {"width":"100%"},
                size: "small",
                "row-class-name": getRowClassName,
                columns: machineColumns,
                "data-source": _unref(data),
                pagination: false
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'machineName')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(getTranslation)(text)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'machineTypeAll')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(getLanguage)(text, _unref(language))), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'factoryId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(getTranslation)(_unref(getFactoryName)(text))), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'groupId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(getTranslation)(_unref(getGroupName)(text))), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'experiment')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(whetherList).find((p) => p.value === text)?.label), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'condition')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", {
                          style: _normalizeStyle([{"width":"14px","height":"14px","border-radius":"50%"}, { background: getMachienCondition(record)?.color }])
                        }, null, 4),
                        _createElementVNode("div", {
                          class: "ml-1",
                          style: _normalizeStyle({ color: getMachienCondition(record)?.color })
                        }, _toDisplayString(_unref(langObj)[getMachienCondition(record)?.label]), 5)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'status')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 6,
                        class: "ml-1",
                        style: _normalizeStyle({ color: getMachienStatus(record)?.color })
                      }, _toDisplayString(_unref(langObj)[getMachienStatus(record)?.label]), 5))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        (_unref(isEditable))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (editMachine(record)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["编辑"]), 9, _hoisted_13))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, { type: "vertical" }),
                        (_unref(admin))
                          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                              key: 1,
                              title: _unref(langObj)['确认删除'] + '?',
                              "ok-text": _unref(langObj)['确认'],
                              "cancel-text": _unref(langObj)['取消'],
                              onConfirm: ($event: any) => (deleteMachine(record))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_14, _toDisplayString(_unref(langObj)["删除"]), 1)
                              ]),
                              _: 2
                            }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(menuSelect) === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_a_form, {
              model: _unref(searchModel),
              name: "horizontal_login",
              layout: "inline",
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['设备区域'],
                  name: "groupId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _unref(searchModel).groupId,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchModel).groupId) = $event)),
                      style: {"width":"220px"},
                      onChange: selectGroup,
                      allowClear: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['设备'],
                  name: "machineId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: _unref(searchModel).machineId,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(searchModel).machineId) = $event)),
                      style: {"width":"220px"},
                      allowClear: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineList), (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: index,
                            value: item.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['测点位置'],
                  name: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: _unref(langObj)['请输入测点位置'],
                      value: _unref(searchModel).keyWord,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(searchModel).keyWord) = $event))
                    }, null, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, {
                  label: _unref(langObj)['传感器SN'],
                  name: "status"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      placeholder: _unref(langObj)['请输入传感器SN'],
                      value: _unref(searchModel).sensorSn,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(searchModel).sensorSn) = $event))
                    }, null, 8, ["placeholder", "value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", {
                        onClick: reset,
                        class: "box px-5 py-1 fff cursor-pointer ml-4"
                      }, _toDisplayString(_unref(langObj)["重置"]), 1),
                      _createElementVNode("div", {
                        onClick: getSensorList,
                        class: "box px-5 py-1 fff cursor-pointer ml-4",
                        style: {"background-color":"#171325ff"}
                      }, _toDisplayString(_unref(langObj)["查询"]), 1),
                      (_unref(isEditable))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            onClick: addSensor,
                            class: "box px-5 py-1 fff cursor-pointer ml-4",
                            style: {"background-color":"#171325ff"}
                          }, _toDisplayString(_unref(langObj)["新建测点"]), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_a_table, {
                style: {"width":"100%"},
                size: "small",
                "row-class-name": getRowClassName,
                columns: sensorColumns,
                "data-source": _unref(data)
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'sensorPlace')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(getTranslation)(text)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'groupId')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(getTranslation)(_unref(getGroupName)(record.machine?.groupId))), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'machineName')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(getTranslation)(record.machine.machineName)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'hardware')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(record?.hardware?.vol || record?.hardware?.vol == 0
                    ? record.hardware.vol + " %"
                    : ""), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'speedRange')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(getSpeenRange(record.defaultSpeed)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'inspectionSubs')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(getInspectionSubs(record.inspectionSubs)), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'disableUse')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(text?_unref(langObj)['禁用']:_unref(langObj)['启用']), 1))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        (record?.disableUse)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (disableUseSensor(record,false)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["启用"]), 9, _hoisted_25))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (disableUseSensor(record,true)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["禁用"]), 9, _hoisted_26)),
                        _createVNode(_component_a_divider, { type: "vertical" }),
                        (_unref(isEditable))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              onClick: ($event: any) => (editSensor(record)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["编辑"]), 9, _hoisted_27))
                          : _createCommentVNode("", true),
                        _createVNode(_component_a_divider, { type: "vertical" }),
                        (_unref(admin))
                          ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                              key: 3,
                              title: _unref(langObj)['确认删除'] + '?',
                              "ok-text": _unref(langObj)['确认'],
                              "cancel-text": _unref(langObj)['取消'],
                              onConfirm: ($event: any) => (deleteSensor(record))
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", _hoisted_28, _toDisplayString(_unref(langObj)["删除"]), 1)
                              ]),
                              _: 2
                            }, 1032, ["title", "ok-text", "cancel-text", "onConfirm"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'parameter')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.sensorGroup, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("div", null, _toDisplayString(_unref(langObj)["传感器编号"]) + ": " + _toDisplayString(item.sonId), 1),
                                  _createElementVNode("div", null, _toDisplayString(_unref(langObj)["安装坐标"]) + ": " + _toDisplayString(item.coordinate), 1),
                                  _createElementVNode("div", null, _toDisplayString(_unref(langObj)["轴名称"]) + ": " + _toDisplayString(_unref(langObj)[item.sensorGroupName]), 1)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_tag, { color: "#2db7f5" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.coordinate), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data-source"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_modal, {
      visible: _unref(visibleAddSensor),
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => (_isRef(visibleAddSensor) ? (visibleAddSensor).value = $event : visibleAddSensor = $event)),
      closable: false,
      footer: null,
      bodyStyle: { background: '#080718ff' },
      style: {"top":"30%"},
      width: "1300px",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(visibleAddSensor) //@ts-ignore
 ? visibleAddSensor.value = false : visibleAddSensor = false))
            }, [
              _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
            ])
          ]),
          _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(sensorForm).id ? _unref(langObj)["编辑测点"] : _unref(langObj)["新建测点"]), 1),
          _createElementVNode("div", _hoisted_34, [
            _createVNode(_component_a_form, {
              ref_key: "sensorForm1",
              ref: sensorForm1,
              model: _unref(sensorForm),
              name: "horizontal_login",
              layout: "inline",
              autocomplete: "off",
              class: "w-full",
              "label-col": { style: { width: '150px' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: "w-full",
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['传感器SN'],
                          name: "sensorSn",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(sensorForm).sensorSn,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(sensorForm).sensorSn) = $event)),
                              placeholder: _unref(langObj)['请输入传感器SN']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['安装位置'],
                          name: "sensorPlace",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(sensorForm).sensorPlace,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(sensorForm).sensorPlace) = $event)),
                              placeholder: _unref(langObj)['请输入安装位置']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['所属设备'],
                          name: "machineName",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_a_input, {
                                value: _unref(sensorForm).machineName,
                                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(sensorForm).machineName) = $event)),
                                placeholder: _unref(langObj)['请选择所属设备'],
                                readonly: ""
                              }, null, 8, ["value", "placeholder"]),
                              _createElementVNode("div", {
                                onClick: selectMachineS,
                                class: "cursor-pointer",
                                style: {"border":"1px solid #171325ff","color":"#fff","background-color":"#171325ff","width":"48px","height":"32px","line-height":"32px","text-align":"center"}
                              }, _toDisplayString(_unref(langObj)["选择"]), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  class: "w-full",
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['转频提取'],
                          name: "fcSensorPlace"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_a_input, {
                                value: _unref(sensorForm).fcSensorPlace,
                                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_unref(sensorForm).fcSensorPlace) = $event)),
                                placeholder: _unref(langObj)['请选择转频提取测点'],
                                readonly: ""
                              }, null, 8, ["value", "placeholder"]),
                              _createElementVNode("div", {
                                onClick: selectSensorS,
                                class: "cursor-pointer",
                                style: {"border":"1px solid #171325ff","color":"#fff","background-color":"#171325ff","width":"48px","height":"32px","line-height":"32px","text-align":"center"}
                              }, _toDisplayString(_unref(langObj)["选择"]), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备类型'],
                          name: "type"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_cascader, {
                              style: {"max-width":"236px"},
                              onChange: changeThirdTypeId,
                              value: _unref(sensorForm).type,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_unref(sensorForm).type) = $event)),
                              options: _unref(machineTypeList),
                              placeholder: _unref(langObj)['请选择设备类型']
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['功率'],
                          name: "national"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              style: {"width":"244px"},
                              value: _unref(sensorForm).national,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_unref(sensorForm).national) = $event)),
                              placeholder: _unref(langObj)['请选择功率'],
                              onChange: changeNational
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(powerEtcList), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.powerEtc
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(getChineseFt)(item.powerEtc)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, {
                      class: "w-full",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: _unref(getLanguage)('巡检设备细分', _unref(language)),
                              name: "inspectionSubId"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_cascader, {
                                  onChange: changeISub,
                                  value: _unref(sensorForm).inspectionSubs,
                                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_unref(sensorForm).inspectionSubs) = $event)),
                                  options: _unref(options),
                                  placeholder: ""
                                }, null, 8, ["value", "options"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: _unref(getLanguage)('转速范围', _unref(language)),
                              name: "defaultSpeed"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  style: {"width":"244px"},
                                  value: _unref(sensorForm).defaultSpeed,
                                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_unref(sensorForm).defaultSpeed) = $event)),
                                  placeholder: _unref(langObj)['请选择']
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(speedList), (item, index) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: index,
                                        value: item._id
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.speedRange), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value", "placeholder"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: _unref(langObj)['是否显示'],
                              name: "disable"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_switch, {
                                  checked: _unref(sensorForm).disable,
                                  "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_unref(sensorForm).disable) = $event)),
                                  "checked-children": _unref(langObj)['隐藏'],
                                  "un-checked-children": _unref(langObj)['显示']
                                }, null, 8, ["checked", "checked-children", "un-checked-children"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_row, {
                      class: "w-full",
                      gutter: 24
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_form_item, {
                              label: _unref(langObj)['是否启用'],
                              name: "disableUse"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_switch, {
                                  checked: _unref(sensorForm).disableUse,
                                  "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_unref(sensorForm).disableUse) = $event)),
                                  "checked-children": _unref(langObj)['禁用'],
                                  "un-checked-children": _unref(langObj)['启用']
                                }, null, 8, ["checked", "checked-children", "un-checked-children"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['数据类型']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _unref(sensorForm).dataType,
                              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(sensorForm).dataType) = $event)),
                              mode: "multiple",
                              placeholder: _unref(langObj)['请选择数据类型']
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataTypeList), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  class: "w-full",
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['备注'],
                          name: "remark",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _unref(sensorForm).remark,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(sensorForm).remark) = $event)),
                              "show-count": "",
                              maxlength: 200,
                              placeholder: _unref(langObj)['请输入备注'],
                              rows: 4
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  class: "w-full",
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['三轴参数'],
                          name: "sn",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_a_table, {
                                style: {"width":"100%"},
                                size: "small",
                                pagination: false,
                                locale: { emptyText: ' ' },
                                columns: sensorAddColumns,
                                "data-source": _unref(sensorForm).sensorGroup
                              }, {
                                bodyCell: _withCtx(({ column, text, index, record }) => [
                                  (column.dataIndex === 'act')
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: ($event: any) => (deleteSensorParmar(index)),
                                        style: {"color":"#00d1c7ff !important"}
                                      }, _toDisplayString(_unref(langObj)["删除"]), 9, _hoisted_38))
                                    : _createCommentVNode("", true),
                                  (column.dataIndex === 'sonId')
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 1,
                                        value: record.sonId,
                                        "onUpdate:value": ($event: any) => ((record.sonId) = $event),
                                        placeholder: _unref(langObj)['请输入编号']
                                      }, null, 8, ["value", "onUpdate:value", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (column.dataIndex === 'coordinate')
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 2,
                                        value: record.coordinate,
                                        "onUpdate:value": ($event: any) => ((record.coordinate) = $event),
                                        placeholder: _unref(langObj)['请输入安装坐标']
                                      }, null, 8, ["value", "onUpdate:value", "placeholder"]))
                                    : _createCommentVNode("", true),
                                  (column.dataIndex === 'sensorGroupName')
                                    ? (_openBlock(), _createBlock(_component_a_input, {
                                        key: 3,
                                        value: record.sensorGroupName,
                                        "onUpdate:value": ($event: any) => ((record.sensorGroupName) = $event),
                                        placeholder: _unref(langObj)['请输入轴名称']
                                      }, null, 8, ["value", "onUpdate:value", "placeholder"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["data-source"]),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("div", {
                                  onClick: addSensorParmar,
                                  class: "ml-4 my-2 cursor-pointer",
                                  style: {"border":"1px solid #171325ff","color":"#fff","background-color":"#171325ff","width":"48px","height":"32px","line-height":"32px","text-align":"center"}
                                }, _toDisplayString(_unref(langObj)["添加"]), 1),
                                _createElementVNode("div", {
                                  onClick: openNodeModal,
                                  class: "ml-4 my-2 cursor-pointer",
                                  style: {"border":"1px solid #171325ff","color":"#fff","background-color":"#171325ff","min-width":"64px","height":"32px","line-height":"32px","text-align":"center"}
                                }, _toDisplayString(_unref(getLanguage)('选择绑定')), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _unref(langObj)['测点照片']
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_upload, {
                          "file-list": _unref(machineFileList),
                          "onUpdate:fileList": _cache[21] || (_cache[21] = ($event: any) => (_isRef(machineFileList) ? (machineFileList).value = $event : machineFileList = $event)),
                          "list-type": "picture-card",
                          onPreview: handlePreview,
                          "custom-request": _unref(customRequest),
                          "auto-upload": false,
                          accept: "image",
                          "max-count": 6
                        }, {
                          default: _withCtx(() => [
                            (!_unref(machineFileList) || _unref(machineFileList).length < 6)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createVNode(_component_plus_outlined),
                                  _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(langObj)["上传"]), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["file-list", "custom-request"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                onClick: submitSensor,
                class: "btn-default py-1 px-6 cursor-pointer"
              }, _toDisplayString(_unref(langObj)["提交"]), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _unref(visibleAddMachine),
      "onUpdate:visible": _cache[41] || (_cache[41] = ($event: any) => (_isRef(visibleAddMachine) ? (visibleAddMachine).value = $event : visibleAddMachine = $event)),
      closable: false,
      footer: null,
      bodyStyle: { background: '#080718ff' },
      style: {"top":"30%"},
      width: "1300px",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_isRef(visibleAddMachine) //@ts-ignore
 ? visibleAddMachine.value = false : visibleAddMachine = false))
            }, [
              _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
            ])
          ]),
          _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(machineForm).id ? _unref(langObj)["编辑设备"] : _unref(langObj)["新建设备"]), 1),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_a_form, {
              ref_key: "macForm",
              ref: macForm,
              model: _unref(machineForm),
              layout: "inline",
              autocomplete: "off",
              class: "w-full",
              "label-col": { style: { width: '180px', wordWrap: 'break-word' } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: "w-full",
                  gutter: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备区域'],
                          name: "groupId",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _unref(machineForm).groupId,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_unref(machineForm).groupId) = $event)),
                              placeholder: _unref(langObj)['请选择设备区域'],
                              onChange: selectGroupM
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: index,
                                    value: item.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备编号'],
                          name: "machineCode"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).machineCode,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_unref(machineForm).machineCode) = $event)),
                              placeholder: _unref(langObj)['请输入设备编号']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备名称'],
                          name: "machineName",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).machineName,
                              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_unref(machineForm).machineName) = $event)),
                              placeholder: _unref(langObj)['请输入设备名称']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备位置'],
                          name: "position"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).position,
                              "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_unref(machineForm).position) = $event)),
                              placeholder: _unref(langObj)['请输入设备位置']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备厂家'],
                          name: "supplier"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).supplier,
                              "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_unref(machineForm).supplier) = $event)),
                              placeholder: _unref(langObj)['请输入设备厂家']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备型号'],
                          name: "model"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).model,
                              "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_unref(machineForm).model) = $event)),
                              placeholder: _unref(langObj)['请输入设备型号']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备类型'],
                          name: "type"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_cascader, {
                              style: {"max-width":"236px"},
                              value: _unref(machineForm).type,
                              "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_unref(machineForm).type) = $event)),
                              options: _unref(machineTypeList),
                              placeholder: _unref(langObj)['请选择设备类型']
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备类型缩写'],
                          name: "machineType"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).machineType,
                              "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_unref(machineForm).machineType) = $event)),
                              placeholder: _unref(langObj)['请输入设备类型缩写']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备SN号'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).sn,
                              "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_unref(machineForm).sn) = $event)),
                              placeholder: _unref(langObj)['请输入设备SN号']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备序号'],
                          name: "sort",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              controls: false,
                              style: {"width":"100%"},
                              value: _unref(machineForm).sort,
                              "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_unref(machineForm).sort) = $event)),
                              placeholder: _unref(langObj)['请输入']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备位号'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).bitNumber,
                              "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_unref(machineForm).bitNumber) = $event)),
                              placeholder: _unref(langObj)['请输入设备位号']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备功率'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).machinePower,
                              "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_unref(machineForm).machinePower) = $event)),
                              placeholder: _unref(langObj)['请输入设备功率']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备ID'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).params.ysshId,
                              "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_unref(machineForm).params.ysshId) = $event)),
                              placeholder: _unref(langObj)['请输入设备ID']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备执行人'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _unref(machineForm).params.ysshExecutor,
                              "onUpdate:value": _cache[37] || (_cache[37] = ($event: any) => ((_unref(machineForm).params.ysshExecutor) = $event)),
                              placeholder: _unref(langObj)['请输入设备执行人']
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['检测类别'],
                          name: "sn"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox_group, {
                              value: _unref(machineForm).mode,
                              "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_unref(machineForm).mode) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(langObj)["在线监测"]), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_checkbox, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(langObj)["巡检"]), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备描述'],
                          name: "remark"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: _unref(machineForm).remark,
                              "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => ((_unref(machineForm).remark) = $event)),
                              placeholder: _unref(langObj)['请输入'],
                              rows: 4
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: _unref(langObj)['设备照片']
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_upload, {
                              "file-list": _unref(machineFileList),
                              "onUpdate:fileList": _cache[40] || (_cache[40] = ($event: any) => (_isRef(machineFileList) ? (machineFileList).value = $event : machineFileList = $event)),
                              "list-type": "picture-card",
                              onPreview: handlePreview,
                              "custom-request": _unref(customRequest),
                              "auto-upload": false,
                              accept: "image",
                              "max-count": 6
                            }, {
                              default: _withCtx(() => [
                                (!_unref(machineFileList) || _unref(machineFileList).length < 6)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _createVNode(_component_plus_outlined),
                                      _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(langObj)["上传"]), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["file-list", "custom-request"])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { class: "w-full" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("div", {
                        onClick: submitMachine,
                        class: "btn-default py-1 px-6 cursor-pointer"
                      }, _toDisplayString(_unref(langObj)["提交"]), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _unref(visibleWarning),
      "onUpdate:visible": _cache[48] || (_cache[48] = ($event: any) => (_isRef(visibleWarning) ? (visibleWarning).value = $event : visibleWarning = $event)),
      closable: false,
      footer: null,
      bodyStyle: { background: '#080718ff' },
      style: {"top":"30%"},
      width: "1400px",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _cache[57] || (_cache[57] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_isRef(visibleWarning) //@ts-ignore
 ? visibleWarning.value = false : visibleWarning = false))
            }, [
              _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
            ])
          ]),
          _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(langObj)["报警记录"]), 1),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_a_form, {
                model: _unref(searchModel),
                name: "horizontal_login",
                layout: "inline",
                autocomplete: "off"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['报警时间'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_range_picker, {
                        value: _unref(warnSearchModel).date,
                        "onUpdate:value": _cache[43] || (_cache[43] = ($event: any) => ((_unref(warnSearchModel).date) = $event)),
                        "disabled-date": disabledDate,
                        onCalendarChange: onCalendarChange
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['报警类型'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(warnSearchModel).type,
                        "onUpdate:value": _cache[44] || (_cache[44] = ($event: any) => ((_unref(warnSearchModel).type) = $event)),
                        style: {"width":"220px"},
                        allowClear: "",
                        placeholder: _unref(langObj)['请选择报警类型']
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(warnTypeList), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(langObj)[item.label]), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, {
                    label: _unref(langObj)['严重程度'],
                    name: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _unref(warnSearchModel).condition,
                        "onUpdate:value": _cache[45] || (_cache[45] = ($event: any) => ((_unref(warnSearchModel).condition) = $event)),
                        style: {"width":"220px"},
                        allowClear: "",
                        placeholder: _unref(langObj)['请选择严重程度']
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionLists), (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              key: index,
                              value: item.value
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(langObj)[item.label]), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", {
                          onClick: resetWarn,
                          class: "box px-5 py-1 fff cursor-pointer ml-4"
                        }, _toDisplayString(_unref(langObj)["重置"]), 1),
                        _createElementVNode("div", {
                          onClick: _cache[46] || (_cache[46] = ($event: any) => ((_unref(warnSearchModel).skip = 1), getWarningList())),
                          class: "box px-5 py-1 fff cursor-pointer ml-4",
                          style: {"background-color":"#171325ff"}
                        }, _toDisplayString(_unref(langObj)["查询"]), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_a_table, {
                style: {"width":"100%"},
                size: "small",
                "row-class-name": getRowClassName,
                columns: _unref(warningColumns),
                "data-source": _unref(warningList),
                pagination: warmPagination.value,
                onChange: changeWarnTable
              }, {
                bodyCell: _withCtx(({ column, text, record }) => [
                  (column.dataIndex === 'type')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (text === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, _cache[58] || (_cache[58] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_0,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, _cache[59] || (_cache[59] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_1,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, _cache[60] || (_cache[60] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_2,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (text === 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, _cache[61] || (_cache[61] = [
                              _createElementVNode("img", {
                                style: {"width":"20px"},
                                src: _imports_3,
                                alt: ""
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_62, _toDisplayString(_unref(langObj)[
                          _unref(warnTypeList).find((p) => p.value === text)?.label
                        ]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'condition')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("div", {
                          style: _normalizeStyle([{"width":"12px","height":"12px","border-radius":"50%"}, {
                        background: _unref(conditionList).find((p) => p.value === text)
                          ?.color,
                      }])
                        }, null, 4),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(langObj)[
                          _unref(conditionList).find((p) => p.value === text)?.label
                        ]), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'status')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_65))
                    : _createCommentVNode("", true),
                  (column.dataIndex === 'act')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (record.type === 1 && record.reportIds?.length)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: ($event: any) => (viewReport(record)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["诊断报告"]), 9, _hoisted_66))
                          : _createCommentVNode("", true),
                        (record.type === 2 && record.reportIds?.length)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: ($event: any) => (viewReport(record)),
                              style: {"color":"#00d1c7ff !important"}
                            }, _toDisplayString(_unref(langObj)["检修报告"]), 9, _hoisted_67))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["columns", "data-source", "pagination"])
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", {
              onClick: _cache[47] || (_cache[47] = ($event: any) => (_isRef(visibleWarning) //@ts-ignore
 ? visibleWarning.value = false : visibleWarning = false)),
              class: "btn-default py-1 px-6"
            }, _toDisplayString(_unref(langObj)["关闭"]), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: _unref(visibleRepair),
      "onUpdate:visible": _cache[51] || (_cache[51] = ($event: any) => (_isRef(visibleRepair) ? (visibleRepair).value = $event : visibleRepair = $event)),
      closable: false,
      footer: null,
      bodyStyle: { background: '#080718ff' },
      style: {"top":"30%"},
      width: "800px",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[49] || (_cache[49] = ($event: any) => (_isRef(visibleRepair) //@ts-ignore
 ? visibleRepair.value = false : visibleRepair = false))
            }, [
              _createVNode(_component_close_outlined, { style: {"font-size":"20px"} })
            ])
          ]),
          _createElementVNode("div", _hoisted_71, _toDisplayString(_unref(langObj)["检修记录"]), 1),
          _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(langObj)["故障信息"]), 1),
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_component_a_table, {
              style: {"width":"100%"},
              size: "small",
              "row-class-name": getRowClassName,
              columns: _unref(repairColumns),
              "data-source": _unref(repairForm).list
            }, {
              bodyCell: _withCtx(({ column, text }) => [
                (column.dataIndex === 'act')
                  ? (_openBlock(), _createElementBlock("a", _hoisted_74, _toDisplayString(_unref(langObj)["编辑"]), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ]),
          _createElementVNode("div", _hoisted_75, _toDisplayString(_unref(langObj)["故障详情"]), 1),
          _createVNode(_component_a_descriptions, {
            column: { xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 },
            labelStyle: { color: '#fff' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_descriptions_item, {
                labelStyle: { color: '#fff' },
                label: "开始时间"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).begin), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "结束时间" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).end), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "设备名称" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).machineName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "设备区域" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).groupName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "检修人员" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).maintainPerson), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_descriptions_item, { label: "现场设备状态" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(repairForm).accuracy), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, _toDisplayString(_unref(langObj)["检修内容"]) + ":", 1),
          _createElementVNode("div", null, _toDisplayString(_unref(repairForm).maintainMessage), 1),
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", null, _toDisplayString(_unref(langObj)["检修照片"]) + ":", 1)
          ]),
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", {
              onClick: _cache[50] || (_cache[50] = ($event: any) => (_isRef(visibleRepair) //@ts-ignore
 ? visibleRepair.value = false : visibleRepair = false)),
              class: "btn-default py-1 px-6"
            }, _toDisplayString(_unref(langObj)["关闭"]), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_drawer, {
      visible: _unref(visibleReport),
      "onUpdate:visible": _cache[52] || (_cache[52] = ($event: any) => (_isRef(visibleReport) ? (visibleReport).value = $event : visibleReport = $event)),
      class: "custom-class",
      size: "large",
      closable: false,
      placement: "right"
    }, {
      title: _withCtx(() => _cache[63] || (_cache[63] = [])),
      default: _withCtx(() => [
        _createVNode(DiagnosticReportDetails, {
          ref_key: "mrDref",
          ref: mrDref,
          reportId: _unref(reportId),
          onCancel: cancel
        }, null, 8, ["reportId"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      visible: previewVisible.value,
      title: "图片",
      footer: null,
      onCancel: handleCancel,
      zIndex: 1001
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: previewImage.value
        }, null, 8, _hoisted_78)
      ]),
      _: 1
    }, 8, ["visible"]),
    (_unref(selectMachineVisible))
      ? (_openBlock(), _createBlock(SelectMachineComponent, {
          key: 0,
          onSelectMachineSen: selectMachineSen,
          visible: _unref(selectMachineVisible)
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_unref(selectSensorVisible))
      ? (_openBlock(), _createBlock(SelectSensorComponent, {
          key: 1,
          onSelectSensorSen: selectSensorSen,
          machineId: _unref(sensorForm).machineId,
          visible: _unref(selectSensorVisible)
        }, null, 8, ["machineId", "visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      width: 600,
      maskClosable: false,
      visible: _unref(modalNodeState).visible,
      "onUpdate:visible": _cache[54] || (_cache[54] = ($event: any) => ((_unref(modalNodeState).visible) = $event)),
      title: _unref(modalNodeState).title,
      "confirm-loading": _unref(modalNodeState).confirmLoading,
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_79, [
          (_unref(nodeList).length > 0)
            ? (_openBlock(), _createBlock(_component_a_tree, {
                key: 0,
                class: "draggable-tree",
                draggable: "",
                "block-node": "",
                "tree-data": _unref(nodeList),
                defaultExpandAll: false,
                onSelect: _unref(selectTree),
                expandedKeys: expandedKeys.value,
                "onUpdate:expandedKeys": _cache[53] || (_cache[53] = ($event: any) => ((expandedKeys).value = $event))
              }, {
                icon: _withCtx(({ key }) => [
                  (key.indexOf('0-') > -1)
                    ? (_openBlock(), _createBlock(_component_BankOutlined, { key: 0 }))
                    : _createCommentVNode("", true),
                  (key.indexOf('1-') > -1)
                    ? (_openBlock(), _createBlock(_component_BankOutlined, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                title: _withCtx(({ title, key }) => [
                  _createVNode(_component_a_dropdown, { trigger: ['contextmenu'] }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        (key.indexOf('10-') > -1)
                          ? (_openBlock(), _createBlock(_component_HddOutlined, {
                              key: 0,
                              class: "jdicon",
                              style: {"color":"#49cc90"}
                            }))
                          : (key.indexOf('21-') > -1)
                            ? (_openBlock(), _createBlock(_component_AimOutlined, {
                                key: 1,
                                class: "jdicon",
                                style: {"color":"#49cc90"}
                              }))
                            : (key.indexOf('22-') > -1)
                              ? (_openBlock(), _createBlock(_component_AimOutlined, {
                                  key: 2,
                                  class: "jdicon",
                                  style: {"color":"#49cc90"}
                                }))
                              : (key.indexOf('23-') > -1)
                                ? (_openBlock(), _createBlock(_component_AimOutlined, {
                                    key: 3,
                                    class: "jdicon",
                                    style: {"color":"#49cc90"}
                                  }))
                                : (key.indexOf('0-') > -1)
                                  ? (_openBlock(), _createBlock(_component_BankOutlined, {
                                      key: 4,
                                      class: "jdicon",
                                      style: {"color":"#49cc90"}
                                    }))
                                  : (key.indexOf('1-') > -1)
                                    ? (_openBlock(), _createBlock(_component_ApartmentOutlined, {
                                        key: 5,
                                        class: "jdicon",
                                        style: {"color":"#49cc90"}
                                      }))
                                    : (_openBlock(), _createBlock(_component_AimOutlined, {
                                        key: 6,
                                        class: "jdicon",
                                        style: {"color":"#49cc90"}
                                      })),
                        _createTextVNode(" " + _toDisplayString(title), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["tree-data", "onSelect", "expandedKeys"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "confirm-loading"])
  ]))
}
}

})